import api from "./LoginService";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ تسجيل الخروج
export const logout = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  try {
    const response = await api.get("/logout", {
      headers,
      params,
    });

    localStorage.removeItem("token");
    sessionStorage.removeItem("token");

    return response.data;
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};


export const login = async ({ email, password, fcm_token }) => {
  const body = new URLSearchParams();
  body.append("api_password", "EcommercApp@2026_$"); // ✅ جرّبها هنا
  body.append("email", String(email || "").trim().toLowerCase());
  body.append("password", String(password || ""));
  body.append("fcm_token", String(fcm_token || "web"));

  const response = await api.post("/guest/login", body, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    // ✅ وخليه موجود في query كمان
    params: { api_password: "EcommercApp@2026_$" },
  });

  return response.data;
};

export const register = async ({
  email,
  password,
  name,
  address,
  phone,
}) => {
  const formData = new FormData();

  formData.append("email", String(email || "").trim().toLowerCase());
  formData.append("password", String(password || ""));
  formData.append("name", String(name || ""));
  formData.append("address", String(address || ""));
  formData.append("phone", String(phone || ""));

  const response = await api.post("/guest/register", formData, {
    headers: {
      Accept: "application/json",
      // ❌ متحطش Content-Type (Axios يظبطه لوحده مع FormData)
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};
// ✅ Verify Account (OTP)
export const verifyAccount = async ({ user_id, otp }) => {
  const formData = new FormData();

  formData.append("user_id", String(user_id));
  formData.append("otp", String(otp));

  const response = await api.post("/guest/verify-account", formData, {
    headers: {
      Accept: "application/json",
      // ❌ متحطش Content-Type مع FormData
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};
// ✅ Resend Verification OTP
export const resendVerificationOtp = async ({ email }) => {
  const formData = new FormData();

  formData.append("email", String(email || "").trim().toLowerCase());

  const response = await api.post(
    "/guest/resend-verification-otp",
    formData,
    {
      headers: {
        Accept: "application/json",
        // ❌ متحطش Content-Type مع FormData
      },
      params: {
        api_password: "EcommercApp@2026_$",
      },
    }
  );

  return response.data;
};

// ✅ Google Auth - Step 1 (Get redirect URL)
export const googleAuth = async () => {
  // endpoint بيرجع { url: "https://accounts.google.com/..." }
  const res = await api.get("/auth/google", {
    headers: {
      Accept: "application/json",
    },
    params: {
      api_password: "EcommercApp@2026_$",
      platform: "web", // مهم لو هتفصل بين web/app بعدين
    },
  });

  return res.data; // { url }
};
// ✅ Step 2: exchange code -> {success, token, user}
export const googleCallback = async ({ code }) => {
  const res = await api.get("/auth/google/callback", {
    params: { code }, // backend لازم يكون بيقرأ code
    headers: { Accept: "application/json" },
  });
  return res.data;
};

// ✅ Forget Password (send reset code)
export const forgetPassword = async ({ email }) => {
  const formData = new FormData();
  formData.append("email", String(email || "").trim().toLowerCase());

  const response = await api.post("/guest/forget-password", formData, {
    headers: {
      Accept: "application/json",
      // ❌ متحطش Content-Type مع FormData
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};
// ✅ Verify Reset Password Code
export const verifyResetCode = async ({ user_id, code }) => {
  const formData = new FormData();
  formData.append("user_id", String(user_id));
  formData.append("code", String(code));

  const response = await api.post("/guest/verify-reset-code", formData, {
    headers: {
      Accept: "application/json",
      // ❌ متحطش Content-Type مع FormData
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};

// ✅ Reset Password (final step)
export const resetPassword = async ({
  user_id,
  new_password,
  new_password_confirmation,
}) => {
  const formData = new FormData();

  formData.append("user_id", String(user_id));
  formData.append("new_password", String(new_password));
  formData.append(
    "new_password_confirmation",
    String(new_password_confirmation)
  );

  const response = await api.post("/guest/reset-password", formData, {
    headers: {
      Accept: "application/json",
      // ❌ متحطش Content-Type مع FormData
    },
    params: {
      api_password: "EcommercApp@2026_$",
    },
  });

  return response.data;
};